export default {
  verticals: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  vertical:[],
  selected_vertical : {},
  vertical_status:[]
}
